/** Copyright © 2024 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/
import { rest } from 'msw';
import { apiWrapper } from '@hems/service/src/util/apiHelper';
import { gridProfileMockData } from '@hems/util/src/mocks/data/gridProfileData';
const API_BASE_URL = process.env.VUE_APP_API_URL;
// DeviceService.getSiteGridProfile 은 managerApiV1 사용 → /manager/api/v1/sites/:id/grid-profile
const SITE_API_URL = `${API_BASE_URL}${apiWrapper.managerApiV1('/sites')}`;
const getSiteGridProfileHandler = rest.get(`${SITE_API_URL}/:id/grid-profile`, (req, res, ctx) => {
    const body = {
        context: {},
        data: gridProfileMockData,
    };
    return res(ctx.status(200), ctx.json(body));
});
export const siteHandlers = [getSiteGridProfileHandler];
